let onlineSubscription;

class DashboardController{
    /*@ngInject*/
    constructor(SocketService,$state,EventService,SessionService){
        this.socket = SocketService;
        this.event = EventService;
        this.$state = $state;
        this.session = SessionService;
    }
    $onInit(){
        this.online = 1;
        this.socket.send('navigate',{page:'dashboard'});
        this.socket.send('getOnline',null);
        onlineSubscription = this.event.subscribe('online',data=>this.online = data.online);
    }

    $onDestroy(){
        onlineSubscription();
    }
    play(level){
        switch(level){
            default:
            case 'easy':
                this.socket.send('setMode',{mode:'easy'});
                break;
            case 'normal':
                this.socket.send('setMode',{mode:'normal'});
                break;
            case 'hard':
                this.socket.send('setMode',{mode:'hard'});
                break;
        }
        this.$state.go('character');
    }
    scores(level){
        this.$state.go('scores',{level:level});
    }
    testLevel(level){
        let levels = this.session.get('levels',7);
        let test = {
            easy:1,
            medium:2,
            hard:4
        };
        return levels === (test[level] | levels);
    }

}

export default DashboardController;


// WEBPACK FOOTER //
// ./public/app/dashboard/dashboard.controller.js